// eslint-disable-next-line 
import util from 'util';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import * as MuiCore from '@material-ui/core';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import Slide from '@material-ui/core/Slide';

/*
 * Show transient messages
 * 
 * type: error, warning, info, success
 */

import * as coreActions from './actions';
import * as coreSelectors from './selectors';

const styles = theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 30,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  title: {
    ...theme.typography.h6
  },
  message: {
    ...theme.typography.body1
  },

});

const icons = {
  error : ErrorIcon,
  info : InfoIcon,
  success : CheckCircleIcon,
  warning : WarningIcon,
};


class SnackMessages extends Component {

  closeItem = () => {
    this.props.setSnackMessageItem({ ...this.props.snackMessageItem, open : false});    
  }

  itemExited = () => {
    if (this.props.snackMessageQueue.length > 0) {
      let newQueue = this.props.snackMessageQueue.slice(1);      
      let nextItem = this.props.snackMessageQueue.splice(0,1)[0];

      this.props.setSnackMessageQueue(newQueue);
      this.props.setSnackMessageItem(nextItem);
    }
    else{
      this.props.setSnackMessageItem(null);
    }
  }
  
  render() {
    const { classes, snackMessageItem } = this.props;
    if(!snackMessageItem){
      return null
    }
    const Icon = icons[snackMessageItem?.type || 'error'];
    let autoHideDuration = snackMessageItem?.duration;
    if (typeof autoHideDuration === 'undefined') {
      autoHideDuration = 1500;
    }
    return (
      <MuiCore.Snackbar
        key = {snackMessageItem.key}
        open = {snackMessageItem.open}
        TransitionComponent={Slide}
        TransitionProps={{ direction : 'left', onExited: this.itemExited }}
        onClose = {this.closeItem}
        anchorOrigin = {{ horizontal: 'right', vertical : 'bottom' }}
        autoHideDuration = {autoHideDuration}>
        
        <MuiCore.SnackbarContent className={classes[snackMessageItem.type]}
                         message = {
                           <MuiCore.Grid container alignItems='center'>
                             <MuiCore.Grid item>
                               <Icon className={classes.icon}/>
                             </MuiCore.Grid>
                             <MuiCore.Grid item>
                               <MuiCore.Grid container>
                                 <MuiCore.Grid item xs={12} className={classes.title}>
                                   {snackMessageItem.title}
                                 </MuiCore.Grid>
                                 <MuiCore.Grid item xs={12} className={classes.message}>
                                   {snackMessageItem.message}
                                 </MuiCore.Grid>
                               </MuiCore.Grid>
                             </MuiCore.Grid>
                           </MuiCore.Grid>
                         }
                         action={[
                           <MuiCore.IconButton key='close'
                                            color='inherit'
                                            className={classes.close}
                                                 onClick={this.closeItem}
                             >
                             <CloseIcon/>
                           </MuiCore.IconButton>,
                         ]}/>
      </MuiCore.Snackbar>
    );
  }
}

const mapStateToProps = (state) => {
  return({ 
    snackMessageQueue : coreSelectors.getSnackMessageQueue(state),
    snackMessageItem : coreSelectors.getSnackMessageItem(state),
  });
};

const mapDispatchToProps = {
  setSnackMessageQueue : coreActions.setSnackMessageQueue,
  setSnackMessageItem : coreActions.setSnackMessageItem,
};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SnackMessages));
